import { Alert } from 'Core/components/Alert';
import { OutlineButton, PrimaryButton } from 'Core/components/Button';
import { Modal } from 'Core/components/Layout';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

export default function UpdateAchModal({ isModalOpen, onModalClose, onModalConfirm }) {
  const { t } = useTranslation();

  const handleConfirm = (e) => {
    if (onModalConfirm) {
      onModalConfirm(e);
    }
  };
  return (
    <Modal isOpen={isModalOpen}>
      <h3 className="font-bold text-center">{t('synchrony.updateAch.title')}</h3>
      <div className="p-6 text-center" data-testid="title-autopay-redirect">
        {t('synchrony.updateAch.intro')}
      </div>

      <div className="">
        <Alert type="shade" data-testid="note-autopay-redirect">
          <b>{t('synchrony.updateAch.noteLabel')} </b>
          <span>
            <Trans
              i18nKey="synchrony.updateAch.note"
              components={{ addAutopay: <em className="font-bold" /> }}
            />
          </span>
        </Alert>
      </div>
      <hr></hr>
      <div className="flex items-end justify-end gap-4">
        <OutlineButton type="button" onClick={onModalClose} data-testid="btn-skip-autopay">
          {t('synchrony.updateAch.skipButton')}
        </OutlineButton>
        <PrimaryButton type="button" onClick={handleConfirm} data-testid="btn-add-autopay">
          {t('synchrony.updateAch.addButton')}
        </PrimaryButton>
      </div>
    </Modal>
  );
}
